import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'de' | 'en';
type TranslationStructure = {
  hero: {
    subtitle: string;
    scroll: string;
  };
  intro: string;
  about: {
    title: string;
    blocks: {
      heading: string;
      text: string;
      link?: string;
    }[];
  };
  beginning: {
    title: string;
    description: string;
  };
  closingCta: string;
  cookie: {
    banner: {
      title: string;
      text: string;
      acceptAll: string;
      settings: string;
      essentialOnly: string;
      privacyLink: string;
    };
    modal: {
      title: string;
      description: string;
      save: string;
      acceptAll: string;
      essential: {
        title: string;
        description: string;
        always: string;
      };
      analytics: {
        title: string;
        description: string;
      };
      marketing: {
        title: string;
        description: string;
      };
    };
  };
  footer: {
    impressum: string;
    datenschutz: string;
  };
  legal: {
    backToHome: string;
  };
};
const translations: Record<Language, TranslationStructure> = {
  de: {
    hero: {
      subtitle: 'Curvy. Blonde. Tattooed. And 100% Me.',
      scroll: 'Scroll'
    },
    intro: 'Willkommen auf meiner offiziellen Webseite. Ich bin Caro Loesel – 27 Jahre alt, blond, kurvig und voller Energie. Mein Look ist feminin, selbstbewusst und unverwechselbar.',
    about: {
      title: 'Über mich',
      blocks: [{
        heading: 'Mein Look & meine Maße',
        text: 'Ich bin 174 cm groß und wiege 62 kg. Meine Figur ist feminin und harmonisch proportioniert – mit natürlichen Kurven, die meinen Körper weich und gleichzeitig präsent wirken lassen. Meine BH-Größe ist 75C, ich trage Kleidergröße 36 (S) und Schuhgröße 40/41. Meine langen blonden Haare sind eines meiner Markenzeichen. Dazu kommen meine grünen Augen, die oft als besonders intensiv beschrieben werden.'
      }, {
        heading: 'Meine Tattoos',
        text: 'Ich habe viele Tattoos und mehrere Piercings, vor allem an den Ohren. Meine Tattoos sind ein Teil meiner Persönlichkeit – sie unterstreichen meinen individuellen Stil und verleihen meinem Look eine starke, moderne Note. Ich stehe für natürliche Weiblichkeit, echte Ausstrahlung und eine selbstbewusste Präsenz vor der Kamera.'
      }, {
        heading: 'Meine Plattformen',
        text: 'Ich veröffentliche regelmäßig exklusive Inhalte auf verschiedenen Plattformen. Dort teile ich Fotos, Videos und persönliche Einblicke in meine Welt. Auf OnlyFans findest du meine privateste Seite mit regelmäßigen Updates. Auf Maloum erwarten dich hochwertige Fotosets und professionelle Produktionen. Über meinen WhatsApp-Chat kannst du mir persönlich schreiben und direkten Kontakt zu mir aufnehmen. Jede Plattform zeigt eine andere Facette von mir – ästhetisch, sinnlich, selbstbewusst.'
      }, {
        heading: 'Buch mich als Model',
        text: 'Neben meinen Online-Plattformen bin ich auch als professionelles Model buchbar. Ob für Fotoshootings, Werbekampagnen, Content-Produktionen oder Messeauftritte – ich bringe Erfahrung, Präsenz und eine starke Ausstrahlung mit. Ich arbeite zuverlässig, professionell und mit einem klaren Gespür für Bildwirkung.',
        link: 'Zur Sedcard auf Model-Kartei'
      }, {
        heading: 'Werde Teil meiner Welt',
        text: 'Wenn du meine exklusive Seite kennenlernen möchtest oder mit mir zusammenarbeiten willst – hier bist du richtig. Ich bin Caro Loesel. Blond. Tätowiert. Kurvig. Und absolut echt.'
      }, {
        heading: 'Meine Leidenschaft',
        text: 'Das Modeln ist für mich mehr als nur ein Job – es ist meine Leidenschaft. Seit 2020 stehe ich vor der Kamera und liebe es, mich immer wieder neu zu erfinden. Jedes Shooting ist eine neue Möglichkeit, Facetten meiner Persönlichkeit zu zeigen und kreative Visionen zum Leben zu erwecken.'
      }, {
        heading: 'Mein Lifestyle',
        text: 'Ich liebe das Leben und genieße jeden Moment. Ob auf Reisen, beim Sport oder einfach in der Natur – ich tanke Energie, wo ich nur kann. Ein gesunder Lifestyle und eine positive Einstellung sind mir wichtig, um mich in meinem Körper wohlzufühlen und diese Energie auch nach außen zu strahlen.'
      }, {
        heading: 'Zukunftsvisionen',
        text: 'Ich habe noch viel vor und freue mich auf alles, was kommt. Mein Ziel ist es, mich stetig weiterzuentwickeln, neue spannende Projekte umzusetzen und meine Community auf diesem Weg mitzunehmen. Bleib dran, es wird aufregend!'
      }]
    },
    beginning: {
      title: 'Caro Beginning',
      description: 'Ich stehe seit 2020 mit großer Leidenschaft vor der Kamera und freue mich darauf es auch in Zukunft zu tun...'
    },
    closingCta: '"Ich bin Caro Loesel. Blond. Tätowiert. Kurvig. Und absolut echt."',
    cookie: {
      banner: {
        title: 'Cookie-Einstellungen',
        text: 'Wir verwenden Cookies und ähnliche Technologien, um Ihnen die bestmögliche Nutzererfahrung zu bieten. Einige Cookies sind technisch notwendig, andere helfen uns, die Website zu verbessern und Inhalte zu personalisieren. Sie können Ihre Einstellungen jederzeit anpassen.',
        acceptAll: 'Alle akzeptieren',
        settings: 'Einstellungen',
        essentialOnly: 'Nur Notwendige',
        privacyLink: 'Datenschutzerklärung'
      },
      modal: {
        title: 'Cookie-Einstellungen',
        description: 'Hier können Sie Ihre Cookie-Einstellungen verwalten. Notwendige Cookies können nicht deaktiviert werden, da sie für die grundlegende Funktionalität der Website erforderlich sind.',
        save: 'Einstellungen speichern',
        acceptAll: 'Alle akzeptieren',
        essential: {
          title: 'Notwendige Cookies',
          description: 'Diese Cookies sind für die grundlegende Funktionalität der Website erforderlich. Sie speichern Ihre Cookie-Einstellungen und Sprachpräferenzen.',
          always: 'Immer aktiv'
        },
        analytics: {
          title: 'Analyse-Cookies',
          description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren. Die Daten werden anonymisiert erfasst und helfen uns, die Website zu verbessern.'
        },
        marketing: {
          title: 'Marketing-Cookies',
          description: 'Diese Cookies werden verwendet, um Ihnen relevante Werbung und personalisierte Inhalte anzuzeigen. Sie können von Drittanbietern gesetzt werden.'
        }
      }
    },
    footer: {
      impressum: 'Impressum',
      datenschutz: 'Datenschutz'
    },
    legal: {
      backToHome: 'Zurück zur Startseite'
    }
  },
  en: {
    hero: {
      subtitle: 'Curvy. Blonde. Tattooed. And 100% Me.',
      scroll: 'Scroll'
    },
    intro: 'Welcome to my official website. I am Caro Loesel – 27 years old, blonde, curvy and full of energy. My look is feminine, confident and unmistakable.',
    about: {
      title: 'About Me',
      blocks: [{
        heading: 'My Look & Measurements',
        text: 'I am 174 cm tall and weigh 62 kg. My figure is feminine and harmoniously proportioned – with natural curves that make my body look soft yet striking. My bra size is 75C, I wear clothing size 36 (S) and shoe size 40/41. My long blonde hair is one of my trademarks. Add to that my green eyes, which are often described as particularly intense.'
      }, {
        heading: 'My Tattoos',
        text: 'I have many tattoos and several piercings, especially on my ears. My tattoos are part of my personality – they accentuate my individual style and give my look a strong, modern edge. I stand for natural femininity, genuine charisma and a confident presence in front of the camera.'
      }, {
        heading: 'My Platforms',
        text: 'I regularly publish exclusive content on various platforms. There I share photos, videos and personal insights into my world. On OnlyFans you will find my most private side with regular updates. On Maloum you can expect high-quality photo sets and professional productions. Through my WhatsApp chat you can write to me personally and get in direct contact. Each platform shows a different facet of me – aesthetic, sensual, confident.'
      }, {
        heading: 'Book Me as a Model',
        text: 'In addition to my online platforms, I am also available as a professional model. Whether for photo shoots, advertising campaigns, content productions or trade fair appearances – I bring experience, presence and a strong charisma. I work reliably, professionally and with a clear sense of visual impact.',
        link: 'View Sedcard on Model-Kartei'
      }, {
        heading: 'Become Part of My World',
        text: 'If you want to discover my exclusive side or work with me – you are in the right place. I am Caro Loesel. Blonde. Tattooed. Curvy. And absolutely real.'
      }, {
        heading: 'My Passion',
        text: 'Modeling is more than just a job for me – it is my passion. Since 2020 I have been in front of the camera and I love reinventing myself again and again. Every shoot is a new opportunity to show facets of my personality and bring creative visions to life.'
      }, {
        heading: 'My Lifestyle',
        text: 'I love life and enjoy every moment. Whether traveling, doing sports or simply being in nature – I recharge my energy wherever I can. A healthy lifestyle and a positive attitude are important to me, to feel comfortable in my body and radiate that energy outward.'
      }, {
        heading: 'Future Visions',
        text: 'I still have a lot planned and look forward to everything that is to come. My goal is to continuously evolve, realize exciting new projects and take my community along on this journey. Stay tuned, it will be exciting!'
      }]
    },
    beginning: {
      title: 'Caro Beginning',
      description: 'I have been passionately in front of the camera since 2020 and look forward to continuing in the future...'
    },
    closingCta: '"I am Caro Loesel. Blonde. Tattooed. Curvy. And absolutely real."',
    cookie: {
      banner: {
        title: 'Cookie Settings',
        text: 'We use cookies and similar technologies to provide you with the best possible user experience. Some cookies are technically necessary, others help us improve the website and personalize content. You can adjust your settings at any time.',
        acceptAll: 'Accept All',
        settings: 'Settings',
        essentialOnly: 'Essential Only',
        privacyLink: 'Privacy Policy'
      },
      modal: {
        title: 'Cookie Settings',
        description: 'Here you can manage your cookie settings. Essential cookies cannot be disabled as they are required for the basic functionality of the website.',
        save: 'Save Settings',
        acceptAll: 'Accept All',
        essential: {
          title: 'Essential Cookies',
          description: 'These cookies are required for the basic functionality of the website. They store your cookie settings and language preferences.',
          always: 'Always active'
        },
        analytics: {
          title: 'Analytics Cookies',
          description: 'These cookies help us understand how visitors interact with the website. Data is collected anonymously and helps us improve the website.'
        },
        marketing: {
          title: 'Marketing Cookies',
          description: 'These cookies are used to show you relevant advertising and personalized content. They may be set by third parties.'
        }
      }
    },
    footer: {
      impressum: 'Impressum',
      datenschutz: 'Privacy Policy'
    },
    legal: {
      backToHome: 'Back to Homepage'
    }
  }
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: TranslationStructure;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('de');
  useEffect(() => {
    const savedLang = localStorage.getItem('lang') as Language;
    if (savedLang && (savedLang === 'de' || savedLang === 'en')) {
      setLangState(savedLang);
    }
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('lang', newLang);
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-156">
      {children}
    </LanguageContext.Provider>;
}
export function useTranslation() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}